import React, { useState } from "react"
import css from "@styled-system/css"

import { Box, Heading } from "./"

function Textarea({ id, label, error, name, ...rest }) {
  const [isFocused, setFocused] = useState(false)

  return (
    <>
      <Heading
        as="label"
        htmlFor={id}
        size={100}
        className={isFocused ? "isFocused" : ""}
        display="block"
        color="text"
        css={css({
          transition: "color 200ms ease-out",
          "&.isFocused": {
            color: "primary",
          },
        })}
      >
        {label}
      </Heading>
      <Box
        as="textarea"
        id={id}
        name={name}
        className={isFocused ? "isFocused" : undefined}
        width="100%"
        m={0}
        py="spacing.4"
        px={0}
        border={0}
        borderBottom="2px solid"
        borderColor="alt"
        borderRadius={0}
        fontFamily="regular"
        fontSize={16}
        color="text"
        bg="transparent"
        css={css({
          transition: "borderColor 200ms ease-out",
          "::placeholder": {
            color: "alt",
            opacity: 1,
          },
          "&:focus": { outline: 0 },
          "&.isFocused": {
            borderColor: "primary",
          },
        })}
        onFocus={() => {
          setFocused(true)
        }}
        onBlur={() => {
          setFocused(false)
        }}
        {...rest}
      />
      <Box
        className={error ? "visible" : ""}
        css={css({
          opacity: 0,
          transition: "opacity 100ms ease-out",
          "&.visible": {
            opacity: 1,
          },
        })}
        role="alert"
      >
        {error && (
          <Heading
            size={100}
            mt={1}
            mb={2}
            id={name + "error"}
            fontWeight={400}
            color="primary"
          >
            ↳{error}
          </Heading>
        )}
      </Box>
    </>
  )
}

export default Textarea
